<checkout-shipping-delivery-address-list (editAddressCommand)="editAddress($event)"></checkout-shipping-delivery-address-list>

<button (click)="updateShippingAddress()" [disabled]="false" class="btn btn-primary w-100 mt-96 mb-16">
    {{ 'dev.myOrders.changeAddress.updateSelection' | translate }}
</button>
